const getPageId = () => {
    const {pathname} = window.location;
    const pathName = pathname.split('/').filter(Boolean);
    const pageId = !!pathName.length ? pathName.pop() : 'welcome';
    return pageId as string;
};

export {getPageId};
